import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=8b9a20a8&scoped=true&"
import script from "./backTop.vue?vue&type=script&lang=js&"
export * from "./backTop.vue?vue&type=script&lang=js&"
import style0 from "./backTop.vue?vue&type=style&index=0&id=8b9a20a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a20a8",
  null
  
)

export default component.exports